import { useEffect, useRef } from 'react';

export function useAutoFocus(shouldFocus: boolean) {
  const ref = useRef<null | HTMLInputElement>(null);

  useEffect(() => {
    if (shouldFocus) {
      ref.current?.focus();
    }
  }, [ref, shouldFocus]);

  return ref;
}
